import { BaseModel, Guid, RecursivePartial } from '@models/base';
import { ParamsFilter } from '@models/filters/params-filter';
import { WorkflowTrigger } from './workflow-trigger';

export class WorkflowTarget extends BaseModel {
    id?: Guid;
    constraints?: ParamsFilter;
    triggers?: WorkflowTrigger[];

    constructor(json?: RecursivePartial<WorkflowTarget>) {
        super(json);
        this.parseWorkflowTarget(json || {});
    }

    parse(json: RecursivePartial<WorkflowTarget>): WorkflowTarget {
        super.parse(json);
        this.parseWorkflowTarget(json);
        return this;
    }

    private parseWorkflowTarget(json: RecursivePartial<WorkflowTarget>): void {
        WorkflowTarget.assignFields(this, json, ['id']);
        WorkflowTarget.assignClassFields(this, json, { constraints: ParamsFilter });
        WorkflowTarget.assignClassArrays(this, json, { triggers: WorkflowTrigger });
    }

}
